export default __webpack_public_path__ + "static/exceed-827068c71457e9b0a8dd1261e3f36b14.svg";